(function (global, factory) {
    if (typeof define === "function" && define.amd) {
        define(['exports', 'prop-types'], factory);
    } else if (typeof exports !== "undefined") {
        factory(exports, require('prop-types'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.propTypes);
        global.Point = mod.exports;
    }
})(this, function (exports, _propTypes) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _propTypes2 = _interopRequireDefault(_propTypes);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    exports.default = _propTypes2.default.shape({
        x: _propTypes2.default.number.isRequired,
        y: _propTypes2.default.number.isRequired
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-image-magnify/dist/Point.js
 ** module id = 1103
 ** module chunks = 0
 **/